document.addEventListener('DOMContentLoaded', () => {

  const stickyComponent = document.querySelector('sticky-add-to-cart');
  const stickyBar = stickyComponent?.querySelector('.sticky-add-to-cart__bar');
  const stickyTarget = stickyComponent?.querySelector('[data-wishlist-target]');
  const originalWrapper = document.querySelector('.shopify-app-block.sa-008-ur-favorite-app');

  if (!stickyBar || !stickyTarget || !originalWrapper) {
    console.log('必要要素未取得');
    return;
  }

  const originalParent = originalWrapper.parentNode;
  const originalNextSibling = originalWrapper.nextSibling;

  const observer = new MutationObserver(() => {

    const isStuck = stickyBar.getAttribute('data-stuck') === 'true';

    if (isStuck) {
      // sticky表示中 → 移動
      if (!stickyTarget.contains(originalWrapper)) {
        stickyTarget.appendChild(originalWrapper);
      }

    } else {
      // sticky非表示 → 元へ戻す
      if (!originalParent.contains(originalWrapper)) {
        if (originalNextSibling) {
          originalParent.insertBefore(originalWrapper, originalNextSibling);
        } else {
          originalParent.appendChild(originalWrapper);
        }
      }
    }

  });

  observer.observe(stickyBar, {
    attributes: true,
    attributeFilter: ['data-stuck']
  });

});
